import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss']
})
export class FAQPage implements OnInit {

  title: string = 'FAQs';

  constructor(private modalController:ModalController) { }

  ngOnInit(): void {
  }

  closeModal() {
    this.modalController.dismiss();
  }

}
